import React from "react";
import Kyc from "./Kyc/kyc.screen";

function App() {
  return <Kyc />;
}

export default App;
